"use strict";

import angular from "angular";

angular.module("nucont.accounting.batchImport").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.batch-import", {
        url: "/lote/:source",
        params: {
            source: {
                value: null,
                dynamic: true
            }
        },
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-batch-import" */ "./batch-import.entry"
            ).then(() => $ocLazyLoad.inject("nucont.accounting.batchImport"));
        },
        views: {
            "admin@nucont.accounting": {
                component: "batchImportComponent"
            }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel4",
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Importação em Lote"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        }
    });
}
